export const tr = {
    'show-banners': 'Göster'
};
